import { render, staticRenderFns } from "./TaskRequestCreate.vue?vue&type=template&id=a32a1db0"
import script from "./TaskRequestCreate.vue?vue&type=script&lang=js"
export * from "./TaskRequestCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports